export var Colors;
(function (Colors) {
    Colors["white"] = "white";
    Colors["black"] = "black";
    Colors["grey"] = "grey";
    Colors["gray"] = "gray";
    Colors["indigo"] = "indigo";
    Colors["purple"] = "purple";
    Colors["pink"] = "pink";
    Colors["epic"] = "epic";
    Colors["legendary"] = "legendary";
    Colors["primary"] = "primary";
    Colors["secondary"] = "secondary";
    Colors["accent"] = "accent";
    Colors["info"] = "info";
    Colors["warning"] = "warning";
    Colors["error"] = "error";
    Colors["success"] = "success";
    Colors["text"] = "text";
    Colors["description"] = "description";
    Colors["background"] = "background";
    Colors["border"] = "border";
    Colors["sms"] = "sms";
    Colors["push"] = "push";
    Colors["viber"] = "viber";
    Colors["whatsapp"] = "whatsapp";
    Colors["telegram"] = "telegram";
    Colors["facebook"] = "facebook";
    Colors["instagram"] = "instagram";
    Colors["flashcall"] = "flashcall";
    Colors["voice"] = "voice";
    Colors["vk"] = "vk";
    Colors["ok"] = "ok";
    Colors["apisender"] = "apisender";
    Colors["email"] = "email";
    Colors["web"] = "web";
    Colors["hlr"] = "hlr";
    Colors["sim_push"] = "sim_push";
    Colors["tgBot"] = "tgBot";
    Colors["incoming_tg_bot"] = "incoming_tg_bot";
    Colors["telegramcode"] = "telegramcode";
    Colors["whatsappchat"] = "whatsappchat";
    Colors["viberchat"] = "viberchat";
    Colors["vkchat"] = "vkchat";
    Colors["telegramchat"] = "telegramchat";
    Colors["facebookchat"] = "facebookchat";
    Colors["tinkoff"] = "tinkoff";
    Colors["mandarin"] = "mandarin";
    Colors["stripe"] = "stripe";
    Colors["accrual"] = "accrual";
    Colors["subtract"] = "subtract";
    Colors["utm"] = "utm";
    Colors["file"] = "file";
    Colors["file-document"] = "file-document";
    Colors["file-pdf"] = "file-pdf";
    Colors["file-sheet"] = "file-sheet";
    Colors["file-image"] = "file-image";
    Colors["file-audio"] = "file-audio";
    Colors["file-video"] = "file-video";
})(Colors || (Colors = {}));
//# sourceMappingURL=colors.js.map